import * as Yup from "yup";
import checkout from "./form";

const {
  formField: { firstName, lastName, username, email, payGroups, role },
} = checkout;

export default Yup.object().shape({
  [firstName.name]: Yup.string().required(firstName.errorMsg),
  [lastName.name]: Yup.string().required(lastName.errorMsg),
  [username.name]: Yup.string().required(username.errorMsg),
  [email.name]: Yup.string().required(email.errorMsg),
  // [plainPassword.name]: Yup.string().required(plainPassword.errorMsg),
  [payGroups.name]: Yup.array().of(Yup.string()),
  [role.name]: Yup.string().required(role.errorMsg),
  // [status.name]: Yup.bool(),
});
